import { Link } from "react-router-dom";
import React, { useState } from "react";
import { Card, CardBody, Col, Nav, NavItem, NavLink, Row } from "reactstrap";
import { pricing2 } from "../../../../common/data";
import classnames from "classnames";

export default function Step1({
  activeTab,
  setActiveTab,
  setChosenPlan,
  chosenPlan,
}) {
  const [activeTabPricePlan, setActiveTabPricePlan] = useState("1");
  return (
    <>
      <Row className="justify-content-center mt-4">
        <Col lg={5}>
          <div className="text-center mb-4">
            <h4 className="fw-semibold fs-22">Plans & Pricing</h4>
            <p className="text-muted mb-4 fs-15">
              Simple pricing. No hidden fees. Advanced features for you
              business.
            </p>

            <div className="d-inline-flex">
              <Nav
                className="nav-pills arrow-navtabs plan-nav rounded mb-3 p-1"
                id="pills-tab"
                role="tablist"
              >
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames(
                      { active: activeTabPricePlan === "1" },
                      "fw-semibold"
                    )}
                    onClick={() => {
                      setActiveTabPricePlan("1");
                    }}
                  >
                    Monthly
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames(
                      { active: activeTabPricePlan === "2" },
                      "fw-semibold"
                    )}
                    onClick={() => {
                      setActiveTabPricePlan("2");
                    }}
                  >
                    Annually <span className="badge bg-success">25% Off</span>
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        {(pricing2 || []).map((price2, key) => (
          <Col lg={4} key={key}>
            <Card className="pricing-box ribbon-box right">
              {price2.ribbon === true ? (
                <div className="ribbon-two ribbon-two-danger">
                  <span>Popular</span>
                </div>
              ) : (
                ""
              )}
              <CardBody className="p-4 m-2">
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <h5 className="mb-1 fw-semibold">{price2.type}</h5>
                    <p className="text-muted mb-0">{price2.purpose}</p>
                  </div>
                  <div className="avatar-sm">
                    <div className="avatar-title bg-light rounded-circle text-primary">
                      <i className={"fs-20 " + price2.icon}></i>
                    </div>
                  </div>
                </div>
                <div className="pt-2 ">
                  <h3 className={"d-flex align-items-center"}>
                    <small>£ </small>

                    {activeTabPricePlan === "2" ? (
                      <div className={"pe-1"}>
                        <del>{price2.rate}</del>{" "}
                        {(Number(price2.rate) / 1.25).toFixed(2)}{" "}
                      </div>
                    ) : (
                      <> {price2.rate}</>
                    )}

                    <span className="fs-13 text-muted">/Month</span>
                  </h3>
                </div>
                <hr className="my-4 text-muted" />
                <div>
                  <ul className="list-unstyled text-muted vstack gap-3">
                    <li>
                      <div className="d-flex">
                        <div className="flex-shrink-0 text-success me-1">
                          <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                        </div>
                        <div className="flex-grow-1">
                          Upto <b>{price2.projects}</b> Projects
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <div className="flex-shrink-0 text-success me-1">
                          <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                        </div>
                        <div className="flex-grow-1">
                          Upto <b>{price2.Customers}</b> Customers
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <div className="flex-shrink-0 text-success me-1">
                          <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                        </div>
                        <div className="flex-grow-1">Scalable Bandwidth</div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <div className="flex-shrink-0 text-success me-1">
                          <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                        </div>
                        <div className="flex-grow-1">
                          <b>{price2.FTP}</b> FTP Login
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <div
                          className={`flex-shrink-0 text-${price2.supportClass} me-1`}
                        >
                          <i
                            className={`ri-${price2.supportClassSymbol}-circle-fill fs-15 align-middle`}
                          ></i>
                        </div>
                        <div className="flex-grow-1">
                          <b>24/7</b> Support
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <div
                          className={`flex-shrink-0 text-${price2.storageClass} me-1`}
                        >
                          <i
                            className={`ri-${price2.storageClassSymbol}-circle-fill fs-15 align-middle`}
                          ></i>
                        </div>
                        <div className="flex-grow-1">
                          <b>Unlimited</b> Storage
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <div
                          className={`flex-shrink-0 text-${price2.domainClass} me-1`}
                        >
                          <i
                            className={`ri-${price2.domainClassSymbol}-circle-fill fs-15 align-middle`}
                          ></i>
                        </div>
                        <div className="flex-grow-1">Domain</div>
                      </div>
                    </li>
                  </ul>
                  <div className="mt-4">
                    <Link
                      to="#"
                      className={`btn btn-${price2.planButtonClassname} w-100 waves-effect waves-light`}
                      onClick={() => {
                        setActiveTab(2);
                        setChosenPlan([price2]);
                      }}
                    >
                      {price2.btntxt}
                    </Link>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
}
